<script setup lang="ts">
import type { Schemas } from "#shopware";
import {addToCartTracking} from "~/components/utilities/GtmTrackings";
import {computed} from "vue";

const { pushError } = useNotifications();
const { trackAddToCart } = useSellograph();
const props = defineProps<{
  product: Schemas["Product"];
}>();
const { product } = toRefs(props);
const { getErrorsCodes } = useCartNotification();
const { t } = useI18n();
const { addToCart, quantity } = useAddToCart(product);
const miniCartController = useModal();


const addToCartProxy = async () => {
  addToCartTracking(product.value, quantity.value);
  trackAddToCart({
    currency: 'CHF',
    value: (product.value.calculatedPrice?.totalPrice || 0) * quantity.value,
    items: [{ item_id: product.value.productNumber, item_name: product.value.translated?.name, item_brand: product.value.manufacturer?.translated?.name, price: product.value.calculatedPrice?.totalPrice, quantity: quantity.value }],
  });
  await addToCart();
  getErrorsCodes()?.forEach((element) => {
    pushError(t(`errors.${element.messageKey}`, { ...element }));
  });
  miniCartController.open()
  //pushSuccess(`<b>${props.product?.translated?.name}</b>` + t("product.messages.addedToCart"),);

};

const loading = ref(true);
onMounted(() => {
  loading.value = false;
});
</script>

<template>
  <SharedModal :controller="miniCartController" popup-class="checkout-side-cart" size="modal-xl">
    <CheckoutSideCart
        class="mini-cart"
        :controller="miniCartController"
        @close="miniCartController.close"
        @success="miniCartController.close"
        :successMessage="`<b>${props.product?.translated?.name}</b>` + $t('product.messages.addedToCart')"
    />
  </SharedModal>

  <div class="product__actions-inner" v-if="product.availableStock > 0">
    <div class="product__count">
      <div class="select select--medium">
        <select id="qty" v-model="quantity" class="form-select" aria-label="Select" data-testid="product-quantity">
          <option v-for="i in Math.min(10, <number>product.calculatedMaxPurchase)" :key="i" :value="i">{{ i }}</option>
        </select>
      </div><!-- /.select -->
    </div><!-- /.product__count -->

    <button
        class="btn btn-default btn-primary product__btn"
        data-testid="add-to-cart-button"
        :disabled="loading"
        @click="addToCartProxy">
      {{ $t("product.addToCart") }}
    </button>
  </div>
  <div class="product__actions-inner" v-else>
    <button disabled="" class="btn btn-default btn-outline-danger btn-outline-danger--alt w-100" href="javascript:;">{{ $t("checkout.items.sold.out") }}</button>
  </div>
</template>
